export default __webpack_public_path__ + "static/media/BuscandoTesoroOn.da0d8be9.png";